import { Info } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useI18n } from "@/context/I18nContext";

export const ModelInfo = ({ details, name, className = "" }) => {
  const { t } = useI18n();
  if (!details) return null;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); }}
          data-testid="model-info-btn"
          aria-label={t("Détails du modèle")}
          className={`inline-flex items-center justify-center text-muted-foreground hover:text-primary transition-colors shrink-0 ${className}`}
        >
          <Info className="w-4 h-4" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-72 text-sm" onClick={(e) => e.stopPropagation()}>
        {name && <div className="font-semibold mb-1 text-foreground">{t(name)}</div>}
        <div className="text-muted-foreground whitespace-pre-line leading-relaxed">{t(details)}</div>
      </PopoverContent>
    </Popover>
  );
};
